import { testimonials } from '@/mocks/homeData';

export default function TestimonialSection() {
  return (
    <section className="relative py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100/70 rounded-full px-3 py-1 font-label mb-4">
            Community Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            Trusted by Thousands of
          </h2>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            Spreadsheet Shoppers Worldwide
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="break-inside-avoid mb-4 md:mb-5 bg-background-100 rounded-2xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-semibold text-sm font-label">{t.avatar}</span>
                </div>
                <div>
                  <p className="font-semibold text-sm text-foreground-900">{t.name}</p>
                  <p className="text-foreground-500 text-xs">@{t.handle}</p>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}